import { AuthServiceResource } from './base';

export default AuthServiceResource('api/v1/users/{/id}/licence_area_and_zones_settings');
